<section class="mb-13 mb-md-14 mt-14">
    <app-title title="EU_PROJECTS.page_title" />
</section>
<section class="mb-13 mb-md-14">
    <app-projects />
</section>
